<template>
    <span v-if="isCallOngoing">{{ callDuration }}</span>
    <template v-if="!activeConversation.hasUserLeftChat">
        <template v-if="activeConversation.loginIds.length > 0 && !activeConversation?.isDraftConversation">
            <span
                @click="!dialogOpened && startMeeting(ConversationRoomTypeEnum.AudioCall)"
                :class="[dialogOpened ? 'cursor-not-allowed' : 'cursor-pointer']"
                title="Audio Call"
                v-if="!isCallOngoing"
            >
                <img src="../../../../../assets/images/chat/audio-call.svg" />
            </span>
            <span
                class="ms-1 ms-md-3 ps-md-1"
                @click="!dialogOpened && startMeeting(ConversationRoomTypeEnum.VideoCall)"
                :class="[dialogOpened ? 'cursor-not-allowed' : 'cursor-pointer']"
                title="Video Call"
                v-if="!isCallOngoing"
            >
                <img src="../../../../../assets/images/chat/video-call.svg" />
            </span>
        </template>
        <template v-if="!isGroupConversation">
            <span class="ms-1 ms-md-3 ps-md-1 cursor-pointer" title="Start a group chat">
                <img src="../../../../../assets/images/chat/add-user.svg" @click="addNewMemberDialog" />
            </span>
        </template>
        <template v-else-if="isGroupConversation">
            <span class="ms-1 ms-md-3 ps-md-1 cursor-pointer" data-bs-toggle="dropdown" title="View and add members">
                <img v-if="!isCallOngoing" src="../../../../../assets/images/chat/add-user.svg" />
                <img v-else src="../../../../../assets/images/chat/add-user-white.svg" />
            </span>
            <div id="member-dropdown" class="dropdown-menu p-0" aria-labelledby="Group-Members">
                <div class="d-flex justify-content-between px-3 py-2 border-bottom">
                    <span class="fw-semibold">Members({{ activeConversation.loginIds.length + 1 }})</span>
                    <img
                        class="cursor-pointer"
                        src="../../../../../assets/images/chat/add-members.svg"
                        @click="addNewMemberDialog"
                    />
                </div>
                <div class="users-list" :class="{ 'custom-scrollbar': userOs == 'Windows' }">
                    <span
                        class="d-flex justify-content-between align-items-center px-3 py-2"
                        v-if="loggedInUserDetails"
                    >
                        <div class="d-flex align-items-center">
                            <AvaInitials
                                classes="ava-sm"
                                :initialsType="AvaInitialsType.Single"
                                :user="loggedInUserDetails"
                                :showStatus="true"
                            />
                            <div>
                                <span class="ps-2 fw-semibold"
                                    >{{ loggedInUserDetails.firstName }} {{ loggedInUserDetails.lastName }}</span
                                ><br />
                                <span class="current-user ps-2">You</span>
                            </div>
                        </div>
                    </span>
                    <span
                        v-for="user in getMultipleUsers(activeConversation.loginIds)"
                        :key="user.userId"
                        class="d-flex justify-content-between align-items-center px-3 py-2"
                    >
                        <div class="d-flex align-items-center">
                            <AvaInitials
                                classes="ava-sm"
                                :initialsType="AvaInitialsType.Single"
                                :user="user"
                                :showStatus="true"
                            />
                            <span class="ps-2 fw-semibold">{{ user.firstName }} {{ user.lastName }}</span>
                        </div>
                        <span class="ms-5"
                            ><img
                                @click="removeParticipant(user)"
                                class="remove-btn"
                                v-tooltip="{ title: `Remove`, placement: 'bottom' }"
                                src="../../../../../assets/images/chat/close.svg"
                        /></span>
                    </span>
                </div>
                <div
                    v-if="activeConversation.loginIds.length > 0 && !activeConversation?.isDraftConversation"
                    class="py-2 px-3 border-top cursor-pointer"
                    @click="leaveGroup"
                >
                    Leave Group
                </div>
            </div>
        </template>
    </template>
    <span class="conversation-join-meeting-btn ms-1 ms-md-3" v-if="showJoinBtn" @click="joinConversationRoom()">
        Join
    </span>
</template>

<script lang="ts" src="./AudioVideoConferencing.ts"></script>
<style src="./AudioVideoConferencing.scss"></style>
